import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, Table, Tag} from "antd";
import Colors from "../../../styles/Colors";
import {BiChild, BiInfoCircle, BiPencil, BiPlus, BiReceipt, BiRefresh, BiTrash} from "react-icons/bi";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye, BsPciCard} from "react-icons/bs";
import PlantillaModal from "../../PlantillaModal";
import PlantillaLista from "../../PlantillaLista";
import RebutFIltre from "../../../model/multilleure/rebuts/RebutFIltre";
import {Dayjs} from 'dayjs';
import {GetContactes} from "../../../dao/multilleure/gestioinscripcions/GetContactes";
import Contacte from "../../../model/multilleure/gestioinscripcions/Contacte";
import ContactesLista from "./components/ContactesLista";
import ContacteModal from "./components/ContacteModal";

const Contactes = () => {
    const titol: string = "Contactes";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Contacte[]>([]);
    const [elementSelected, setElementSelected] = useState<Contacte>(new Contacte());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [surenameFiltres, setSurenameFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);


    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());

    useEffect(() => {
        handleLoadingChange(true)
        if(isLoggedIn){
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetContactes(page);
        setDades(dades);
        await setNameFilters(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        //await DeleteContacte(id, page);
        await checkDades();
    }

    function afegirElement(element: Contacte) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElement(element: Contacte) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function handleCloseModal() {
        setNouElement(false);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Contacte[]) {
        if (elements?.length > 0) {
            const ContacteNames = elements.map((element) => ({
                text: element.nom,
                value: element.nom,
            }));
            setNomFiltres(ContacteNames);
        }
    }

    function setSurenameFilters(elements: Contacte[]) {
        if (elements?.length > 0) {
            const ContacteNames = elements.map((element) => ({
                text: element.cognoms,
                value: element.cognoms,
            }));
            setSurenameFiltres(ContacteNames);
        }
    }

    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };

    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    /**
     * --- FILTRES ----
     **/

    const columns: ColumnsType<Contacte> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'cognoms',
            title: 'Cognoms',
            dataIndex: 'cognoms',
            width: 30,
            filterSearch: true,
            filters: surenameFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.cognoms.startsWith(value) : false),
        },
        {
            key: 'telefon',
            title: 'Telefons',
            dataIndex: 'telefon',
            width: 30,
            render: (estat, ele) => (
                <>
                    <Tag>{ele.telefon !== "0" ? ele.telefon : ""}</Tag>
                    <Tag>{ele.telefon2 !== "0" ? ele.telefon2 : ""}</Tag>
                    <Tag>{ele.telefon3 !== "0" ? ele.telefon3 : ""}</Tag>
                </>
            ),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElement(ele)}><BiPencil/></Button>
                    {" "}
                    <Button title={"Veure Inscripcions"} style={{backgroundColor: Colors.colors.color5}}
                            onClick={() => deleteElement(ele.id)}><BiChild/></Button>
                    {" "}
                    <Button title={"Veure Rebuts"} style={{backgroundColor: Colors.colors.color4}}><BiReceipt/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<Contacte> = {
        loading
    };

    const onChange: TableProps<Contacte>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: Contacte) => {
        return (
            <ContactesLista element={ele}/>
        );
    };

    if (isLoggedIn) {
        return (
            <div>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                afegirElement(new Contacte())}><BiPlus/></Button>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={coleccio}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={"CONTACTES"} pagina={page}/>
                    {nouElement && (
                        <ContacteModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Contactes;
